import { ANIMATION_TYPES } from '@apps/admin/routes/WebsiteEditor/context/NavigationPaneContext/NavigationPane.constants';
import { CUSTOM_PAGE_ACTIONS } from '../CustomComponents.constants';

export enum JSON_COMPONENT_ACTIONS {
  JSON_COMPONENT_ADD = 'json_component_add',
  JSON_COMPONENT_EDIT = 'json_component_edit',
}

export const JSON_COMPONENT_SCREENS = [JSON_COMPONENT_ACTIONS.JSON_COMPONENT_ADD, JSON_COMPONENT_ACTIONS.JSON_COMPONENT_EDIT];

export const JSON_COMPONENT_ANIMATION_CONFIG = {
  [CUSTOM_PAGE_ACTIONS.CUSTOM_COMPONENTS]: [
    {
      navigatedFrom: JSON_COMPONENT_ACTIONS.JSON_COMPONENT_ADD,
      animationType: ANIMATION_TYPES.OVERLAY_VIEW,
    },
    {
      navigatedFrom: JSON_COMPONENT_ACTIONS.JSON_COMPONENT_EDIT,
      animationType: ANIMATION_TYPES.OVERLAY_VIEW,
    },
  ],
  [CUSTOM_PAGE_ACTIONS.CUSTOM_COMPONENTS_ADD]: [
    {
      navigatedFrom: JSON_COMPONENT_ACTIONS.JSON_COMPONENT_ADD,
      animationType: ANIMATION_TYPES.OVERLAY_VIEW,
    },
    {
      navigatedFrom: JSON_COMPONENT_ACTIONS.JSON_COMPONENT_EDIT,
      animationType: ANIMATION_TYPES.OVERLAY_VIEW,
    },
  ],
  [JSON_COMPONENT_ACTIONS.JSON_COMPONENT_ADD]: [
    {
      navigatedFrom: CUSTOM_PAGE_ACTIONS.CUSTOM_COMPONENTS,
      animationType: ANIMATION_TYPES.OVERLAY_VIEW,
    },
    {
      navigatedFrom: CUSTOM_PAGE_ACTIONS.CUSTOM_COMPONENTS_ADD,
      animationType: ANIMATION_TYPES.OVERLAY_VIEW,
    },
  ],
  [JSON_COMPONENT_ACTIONS.JSON_COMPONENT_EDIT]: [
    {
      navigatedFrom: CUSTOM_PAGE_ACTIONS.CUSTOM_COMPONENTS,
      animationType: ANIMATION_TYPES.OVERLAY_VIEW,
    },
  ],
};
